import React from "react"
import "./audioCard.scss"
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, MARKS } from '@contentful/rich-text-types';
import axios from 'axios';
import fileDownload from 'js-file-download';

interface AudioCardProps {
    audio: any;
    download?: boolean;
  }

const AudioCard = (props: AudioCardProps) => {

   const Bold = (children:any) => (
      <p className="a-audio__content__titles__text--bold">{children}</p>
   );
   
   const Text = (children:any) => (
      <p className="a-audio__content__titles__text">{children}</p>
   )

   const List = (children:any) => (
      <li className="a-audio__content__titles__list">{children}</li>
   )
   
   const textOptions = {
      renderMark: {
         [MARKS.BOLD]: (text:any) => Bold(text)
      },
      renderNode: {
         [BLOCKS.LIST_ITEM]: (_node:any, children:any) => List(children),
         [BLOCKS.PARAGRAPH]: (_node:any, children:any) => Text(children)
      },
   };

   // useEffect(() => {
   //    let audioCard: any = document.getElementById('audioCard');
   //    let ctrl: any = document.getElementById('audioControl');
   //    console.log("AUDIOCARD", audioCard)

   //    ctrl.onclick = function () {

   //       // Update the Button
   //       let pause = ctrl.innerHTML === 'pause!';
   //       ctrl.innerHTML = pause ? 'play!' : 'pause!';
     
   //       // Update the Audio
   //       let method = pause ? 'pause' : 'play';
   //       audioCard[method]();
     
   //       // Prevent Default Action
   //       return false;
   //   };

   // }, [])


   const downloadFile = async (url: string, filename: string) => {
      axios.get(url, {
         responseType: 'blob',
       })
       .then((res) => {
         fileDownload(res.data, filename)
       })
   }

   return (
      <div className="a-audio">
         <div className="a-audio__cover">
            <img src={props.audio.imagenPrincipal[0].file.url} alt=""/>
         </div>
         <div className="a-audio__content">
            <div className="a-audio__content__titles">
               <h3 className="a-audio__content__titles__main">{props.audio.tituloBanner}</h3>
               {documentToReactComponents(props.audio.descripcion.json, textOptions)}
            </div>
            {props.download ?
               <div className="a-audio__content__download">
                  <span onClick={() => downloadFile(props.audio.audioPrincipal.file.url, `${props.audio.audioPrincipal.title}.mp3`)} >
                     DESCARGAR <i className="icon-download"></i>
                  </span>
               </div>
            :
               null
            }
            <audio id="audioCard" className="a-audio__content__audio" src={props.audio.audioPrincipal.file.url} preload="auto" controls></audio>
            {/* <a href="#" id="audioControl">play!</a> */}
         </div>
      </div>
   )
}

export default AudioCard